import { Constants } from '@hvf/contracts'
import * as v from 'valibot'

export const VideoSchema = v.pipe(
	v.object({
		title: v.pipe(
			v.string(),
			v.minLength(1, 'Title is required'),
			v.maxLength(200, 'Title must be less than 200 characters'),
		),
		topic: v.picklist(Constants.public.Enums.go_watch_topic),
		provider: v.picklist(Constants.public.Enums.video_providers),
		provider_id: v.pipe(
			v.string(),
			v.minLength(1, 'Paste a YouTube, Vimeo or Dailymotion link above'),
		),
		thumbnail_url: v.optional(v.nullable(v.string())),
		description: v.optional(
			v.pipe(
				v.string(),
				v.maxLength(2000, 'Description must be less than 2000 characters'),
			),
		),
	}),
)

export type VideoForm = v.InferInput<typeof VideoSchema>
